export default __webpack_public_path__ + "static/media/TV2.ee72d4e7.mp4";